var createStylesheet = function(chunkId, fullhref, resolve, reject) {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = function(event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	2143: 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"8":1,"95":1,"160":1,"225":1,"276":1,"344":1,"382":1,"384":1,"556":1,"620":1,"825":1,"859":1,"1352":1,"1368":1,"1373":1,"1514":1,"1530":1,"1537":1,"1545":1,"1549":1,"1658":1,"1847":1,"1944":1,"1950":1,"2138":1,"2139":1,"2256":1,"2446":1,"2485":1,"2630":1,"2641":1,"2651":1,"2676":1,"2791":1,"2814":1,"2862":1,"2870":1,"2893":1,"3014":1,"3047":1,"3139":1,"3344":1,"3412":1,"3422":1,"3663":1,"3707":1,"3926":1,"3996":1,"4101":1,"4198":1,"4244":1,"4443":1,"4565":1,"4847":1,"4848":1,"5276":1,"5281":1,"5336":1,"5380":1,"5590":1,"5611":1,"5735":1,"5823":1,"5856":1,"6078":1,"6126":1,"6223":1,"6268":1,"6370":1,"6473":1,"6707":1,"6906":1,"7056":1,"7059":1,"7099":1,"7100":1,"7157":1,"7347":1,"7741":1,"7769":1,"7820":1,"8004":1,"8448":1,"8461":1,"8476":1,"8512":1,"8760":1,"8789":1,"9067":1,"9741":1,"9949":1,"9992":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr